var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 px-1",
    attrs: {
      "id": "small-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "top-spacer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between flex-column flex-grow-1"
  }, [_c('ul', _vm._l((_vm.links), function(link) {
    return (_vm.shouldDisplay(link)) ? _c('li', {
      key: link.index,
      staticClass: "link mb-3"
    }, [_c('SidebarIcon', {
      attrs: {
        "link": link
      }
    })], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "icon-container d-flex justify-content-center align-items-center",
    on: {
      "click": _vm.handleLogout
    }
  }, [_c('b-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "door-open",
      "title": "logout"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottom-spacer"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a759f5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Layout/Sidebar/SmallSidebar.vue
// module id = oyRz
// module chunks = 2